<div class="dropdown-options-modal">
  <div class="modal-header">
    <h3>{{ 'builderScreen.inspector.dropdownOptionsModal.title' | translateTA }}</h3>
    <p class="help-text">{{ 'builderScreen.inspector.dropdownOptionsModal.description' | translateTA }}</p>
  </div>

  <form [formGroup]="form" class="modal-content">
    <div formArrayName="options" class="options-list">
      <div class="options-header">
        <div class="header-col value-col">{{ 'builderScreen.inspector.dropdownOption.value' | translateTA }}</div>
        <div class="header-col label-col">{{ 'builderScreen.inspector.dropdownOption.label' | translateTA }}</div>
        <div class="header-col default-col">{{ 'builderScreen.inspector.dropdownOption.isDefault' | translateTA }}</div>
        <div class="header-col actions-col"></div>
      </div>

      <div *ngFor="let option of optionsArray.controls; let i = index; trackBy: trackByIndex" 
           [formGroupName]="i"
           class="option-row">
        
        <nz-form-item class="form-item value-col">
          <nz-form-control [nzErrorTip]="'builderScreen.inspector.dropdownOption.value.required' | translateTA">
            <input 
              nz-input 
              formControlName="value" 
              [placeholder]="'builderScreen.inspector.dropdownOption.value.placeholder' | translateTA"
              nzSize="default" />
          </nz-form-control>
        </nz-form-item>
        
        <nz-form-item class="form-item label-col">
          <nz-form-control [nzErrorTip]="'builderScreen.inspector.dropdownOption.label.required' | translateTA">
            <input 
              nz-input 
              formControlName="label" 
              [placeholder]="'builderScreen.inspector.dropdownOption.label.placeholder' | translateTA"
              nzSize="default" />
          </nz-form-control>
        </nz-form-item>
        
        <div class="default-col">
          <label nz-checkbox 
            formControlName="isDefault"
            (ngModelChange)="onDefaultChange(i)"
            [nz-tooltip]="'builderScreen.inspector.dropdownOption.isDefault.tooltip' | translateTA">
          </label>
        </div>
        
        <div class="actions-col">
          <button 
            nz-button 
            nzType="text" 
            nzDanger
            nzSize="small"
            (click)="removeOption(i)"
            [nz-tooltip]="'builderScreen.inspector.dropdownOption.remove' | translateTA"
            [disabled]="optionsArray.length === 1">
            <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
          </button>
        </div>
      </div>
    </div>

    <button 
      nz-button 
      nzType="dashed" 
      nzBlock
      (click)="addOption()"
      class="add-option-btn">
      <nz-icon nzType="plus" nzTheme="outline"></nz-icon>
      {{ 'builderScreen.inspector.dropdownOption.add' | translateTA }}
    </button>
  </form>

  <div class="modal-footer">
    <button nz-button nzType="default" (click)="handleCancel()">
      {{ 'builderScreen.inspector.dropdownOptionsModal.cancel' | translateTA }}
    </button>
    <button nz-button nzType="primary" (click)="handleOk()">
      {{ 'builderScreen.inspector.dropdownOptionsModal.save' | translateTA }}
    </button>
  </div>
</div>
